import React from 'react';

export const RewardsIntro: React.FC = () => (
  <div className="text-center px-4" data-testid="rewards-step">
    <h2 className="text-2xl font-bold text-center mb-4">
      Earn Amazing Rewards!
    </h2>
    <p className="text-center text-neutral-800 text-opacity-80 text-base font-normal mb-6">
      Get high accuracy in your quizzes to unlock loot boxes that may contain
      Video Generation Tokens, Universe or Character Creation Tokens, Special
      Character and Event Cards, and Coins!
    </p>
    <section className="flex flex-col justify-center self-stretch bg-gray-200 rounded-xl my-4">
      <img
        loading="lazy"
        src={require('../../../assets/book-builder-rewards.png')}
        alt="Book Builder Rewards"
        className="max-w-full"
      />
    </section>
    <p className="text-center text-neutral-800 text-opacity-80 text-base font-normal">
      Use these cards to create your own amazing books, and create videos for
      them!
    </p>
  </div>
);

export default RewardsIntro;
